import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ViewModeService {

  private viewModes = new Map<string, BehaviorSubject<boolean>>();

  getViewMode(pageKey: string): BehaviorSubject<boolean> {
    if (!this.viewModes.has(pageKey)) {
      // Try to read value from localStorage or default to false
      const stored = localStorage.getItem('view_mode_list_' + pageKey.toLocaleLowerCase());
      this.viewModes.set(pageKey, new BehaviorSubject<boolean>(stored === 'true'));
    }
    return this.viewModes.get(pageKey)!;
  }

  setViewMode(pageKey: string, value: boolean) {
    localStorage.setItem('view_mode_list_' + pageKey.toLocaleLowerCase(), value ? 'true' : 'false');
    this.getViewMode(pageKey).next(value);
  }

}
